/**
 * Support for functional programming.
 */

export function existy(x) {
  return x != null;
}

export function truthy(x) {
  return ((x !== false) && existy(x));
}

